import React from 'react';

import type {
	StripeCardCvcElementChangeEvent,
	StripeCardExpiryElementChangeEvent,
	StripeCardNumberElementChangeEvent,
} from '@stripe/stripe-js';

import type { WithTokenParams } from 'src/app/shared/types';
import type { PaymentMethodSaveOptions, PaymentType } from 'src/app/shared/utils/payments';

import { StripeCreditCardLayout } from '../../../../stripe/containers/experiment/layout';

import { useNewPaymentMethodStripe } from './hooks/useNewPaymentMethodStripe';

export type NewPaymentMethodStripeProps = {
	email: string;
	name: string;
	paymentMethodSaveOptions: PaymentMethodSaveOptions;
	beforeToken: (paymentType: PaymentType) => Promise<boolean>;
	onTokenError: (paymentType: PaymentType, err: Error) => void;
	onTokenInvalid: (paymentType: PaymentType, err: Error) => void;
	withToken: (params: WithTokenParams) => Promise<void>;
	validate: (paymentType: PaymentType) => Promise<boolean>;
	prePaymentChecks: (paymentType: PaymentType) => Promise<boolean>;
	submitButton: React.JSX.Element;
	phoneNumberInput: React.JSX.Element;
	onChange?: (
		e: StripeCardNumberElementChangeEvent | StripeCardExpiryElementChangeEvent | StripeCardCvcElementChangeEvent,
	) => void;
};

export function NewPaymentMethodStripe({
	submitButton,
	phoneNumberInput,
	...props
}: NewPaymentMethodStripeProps): React.JSX.Element {
	const { data, actions } = useNewPaymentMethodStripe(props);

	return (
		<StripeCreditCardLayout
			{...data}
			{...actions}
			labelWeight="bold"
			layout="single"
			data-testid="stripe-form"
			submitButton={submitButton}
			phoneNumberInput={phoneNumberInput}
		/>
	);
}
